"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.homePageReducer = void 0;
var redux_1 = require("redux");
var Pages_1 = require("@/rendering/common/Pages");
var RootPublicPageReducer_1 = require("@/pages/common/reducers/RootPublicPageReducer");
var HomeReducer_1 = require("@/pages/home/reducers/HomeReducer");
var MobilePromoReducer_1 = require("@/pages/common/reducers/MobilePromoReducer");
var FgpPopReducer_1 = require("@/pages/common/reducers/FgpPopReducer");
exports.homePageReducer = {
    page: function (state) {
        if (state === void 0) { state = Pages_1.Pages.HOME; }
        return state;
    },
    home: HomeReducer_1.homeReducer,
};
var combinedReducer = redux_1.combineReducers(__assign(__assign(__assign({}, RootPublicPageReducer_1.default), exports.homePageReducer), { mobilepromo: MobilePromoReducer_1.mobilePromoReducer, fgppop: FgpPopReducer_1.fgpPopReducer }));
var rootHomeReducer = function (state, action) {
    if (action.type === 'SET_ALL_STATE_HOME') {
        return __assign(__assign({}, state), action.payload);
    }
    return combinedReducer(state, action);
};
exports.default = rootHomeReducer;
